import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useSelector, useDispatch } from "react-redux";
import * as constantMessages from "../../constants/constatntMessages";
import { updateMinute } from "../../redux/actions/minuteActions/MinuteAction";
import {
  fetchCurrentAttendeesList,
  fetchExistingGuest,
} from "../../redux/actions/meetingActions/MeetingAction";
import { getEmployeeList } from "../../redux/actions/userAction/userAction";
import Select from "react-select";
import {
  checkEmptyString,
  cleanInput,
  getStringLengthAfterHTMLParse,
} from "../../helpers/commonHelpers";
import ReactQuill from "../../../node_modules/react-quill/lib/index";
import { decryptWithAES, encryptWithAES } from "../../helpers/commonHelpers";
import LoaderButton from "../Common/LoaderButton";
import { checkDuplicateUser } from "../../redux/actions/userAction/userAction";
import RemoveAttendeesModalAction from "../Meeting/RemoveAttendeesModalNew";
import AttendeeDragDropNew from "../Meeting/AttendeeDragDropNew";

import SmallLoaderButton from "../Common/SmallLoaderButton";
const regularExpressionForAgendaTitle =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;

const EditMinuteModal = (props) => {
  const { minuteData } = props;
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };
  const minuteDatas = useSelector((state) => state.minute);
  const formats = ["header", "bold", "italic", "underline", "list", "bullet"];
  const regularExpression = /^[0-9a-zA-Z .,:;&$%@#()/\-_]+$/;
  const regularExpressionName = /^[0-9a-zA-Z .,:;()/\-_]+$/;

  const meetingData = useSelector((state) => state.meeting);
  const employeeData = useSelector((state) => state.user);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [description, setDescription] = useState("");

  // const [selectedAttendeeOption, setSelectedAttendeeOption] = useState([
  //   { label: "Name / Email Address", value: "" },
  // ]);
  // const [selectedEmployeeOption, setSelectedEmployeeOption] = useState([
  //   { label: "*Name / Emp Id", value: "" },
  // ]);
  const [selectedAttendeeOption, setSelectedAttendeeOption] = useState(null);
  const [selectedEmployeeOption, setSelectedEmployeeOption] = useState(null);
  const guestTypeOptions = [
    { value: "new", label: "Add New Guest" },
    { value: "existing", label: "Select from Existing" },
  ];
  const [addNewPeopleType, setAddNewPeopleType] = useState(""); // new state
  // const [existingGuestOptions, setExistingGuestOptions] = useState([
  //   { label: "*Name / Email Address", value: "" },
  // ]);
  const [existingGuestOptions, setExistingGuestOptions] = useState([]);
  const [selectedExistingGuestOption, setSelectedExistingGuestOption] =
    useState(null);
  const [addNewSubOption, setAddNewSubOption] = useState("");

  const [attendeeOptions, setAttendeeOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [attendData, setAttendData] = useState([
    { _id: "", name: "", email: "", profilePicture: "" },
  ]);
  const [addedUserError, setAddedUserError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [removeAttendeeData, setRemoveAttendeeData] = useState({});
  const [allGuestList, setAllGuestList] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    dueDate: "",
    priority: "",
    attendyType: "fromCurrentMeeting",
    // responsiblePersonId: "",
    responsibleUser: [],
    isAction: false,
    name: "",
    email: "",
    designation: "",
    companyName: "",
    role: "",
    department: "",
  });

  console.log(minuteData);
  useEffect(() => {
    if (minuteData?.dueDate) {
      var date = new Date(minuteData?.dueDate);
      var dateString = new Date(
        date?.getTime() - date?.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];
    }
    setFormData({
      ...formData,
      title: minuteData?.title,
      dueDate: minuteData?.isAction === true ? dateString : "",
      priority: minuteData?.isAction === true ? minuteData?.priority : "",
      attendyType: "fromCurrentMeeting",
      responsibleUser: minuteData?.assignedUsersDetails,
      isAction: minuteData?.isAction,
      name: minuteData?.name,
      email: minuteData?.email,
      designation: minuteData?.designation,
      companyName: minuteData?.companyName,
      role: minuteData?.role,
      department: minuteData?.department,
    });
    setDescription(decryptWithAES(minuteData?.description));

    if (formData.attendyType === "fromCurrentMeeting") {
      if (accessToken) {
        dispatch(
          fetchCurrentAttendeesList(
            userData.organizationId,
            meetingData?.meetingDetails?._id,
            accessToken
          )
        );
      }
    }

    if (minuteData?.assignedUserDetails && minuteData?.isAction === true) {
      setSelectedAttendeeOption({
        value: minuteData?.assignedUserDetails?._id,
        label:
          minuteData?.assignedUserDetails?.name +
          " / " +
          minuteData?.assignedUserDetails?.email,
        name: "responsibleUser",
      });
    }
    setSelectedEmployeeOption([{ label: "Name / Emp Id", value: "" }]);
  }, [props.IsEditMinuteModal, minuteDatas?.isSuccess]);

  // useEffect(() => {
  //   setErrors({});
  //   if (minuteDatas?.isSuccess) {
  //     props.setIsEditMinuteModal(false);
  //   }
  //   setAttendData(props.minuteData?.assignedUserDetails)
  //   console.log(props.minuteData)

  //   // if (Array.isArray(props.minuteData?.assignedUserDetails)) {
  //   //   setAttendData((prevAttendData) => {
  //   //     const existingAttendees = prevAttendData || [];

  //   //     const newAttendees = props.minuteData?.assignedUserDetails.filter((newUser) => {
  //   //       const newUserId = newUser.id || newUser._id || "";
  //   //       const newUserEmail = newUser.email || "";

  //   //       // Check if the user is already in the attendee list
  //   //       return !existingAttendees.some((attendee) => {
  //   //         const existingId = attendee.id || attendee._id || "";
  //   //         const existingEmail = attendee.email || "";
  //   //         return (
  //   //           (newUserId && newUserId === existingId) ||
  //   //           (newUserEmail && newUserEmail === existingEmail)
  //   //         );
  //   //       });
  //   //     });

  //   //     return [...existingAttendees, ...newAttendees];
  //   //   });
  //   // }
  //   console.log(attendData)
  // }, [props.IsEditMinuteModal, minuteDatas?.isSuccess]);

  useEffect(() => {
    setErrors({});

    if (minuteDatas?.isSuccess) {
      props.setIsEditMinuteModal(false);
    }

    const assignedDetails = props.minuteData?.assignedUsersDetails;

    if (Array.isArray(assignedDetails)) {
      const cleaned = assignedDetails
        .map((user) => {
          const _id = typeof user._id === "string" ? user._id : "";
          const name = user.name?.trim() || "";
          const email = user.email?.trim() || "";
          const profilePicture = user.profilePicture || "";

          // Ensure required fields are valid
          if (!_id || !email) return null;

          return {
            _id,
            name,
            email,
            profilePicture,
          };
        })
        .filter(Boolean);

      setAttendData(cleaned);
    } else {
      setAttendData([]);
    }

    console.log("attendData (from minuteData):", attendData);
  }, [props.IsEditMinuteModal, minuteDatas?.isSuccess]);

  useEffect(() => {
    setErrors({});
    setAddNewPeopleType(""); //
  }, [props.IsEditMinuteModal]);

  useEffect(() => {
    if (meetingData?.currentAttendeesList?.length > 0) {
      const filtered = meetingData.currentAttendeesList.filter((attendee) => {
        return !attendData?.some(
          (assigned) =>
            assigned.email?.toLowerCase() === attendee.email?.toLowerCase()
        );
      });

      const meetingAttendee = filtered.map((attendee) => ({
        value: attendee._id,
        label: `${attendee.name} / ${attendee.email}`,
        name: "attendeeId",
        profilePicture: attendee.profilePicture,
      }));

      setAttendeeOptions(meetingAttendee);
    }
  }, [meetingData, attendData]);

  useEffect(() => {
    if (employeeData?.employeeList?.length > 0) {
      const filtered = employeeData.employeeList.filter((emp) => {
        return !attendData?.some(
          (att) => att.email?.toLowerCase() === emp.email?.toLowerCase()
        );
      });

      const employeeOpt = filtered.map((attendee) => ({
        value: attendee._id,
        label: `${attendee.name} / ${attendee.empId}`,
        email: attendee.email,
        profilePicture: attendee.profilePicture,
        isEmployee: true,
      }));

      setEmployeeOptions(employeeOpt);
    }
  }, [employeeData, attendData]);

  useEffect(() => {
    const fetchGuests = async () => {
      try {
        const response = await dispatch(
          fetchExistingGuest(userData.organizationId, accessToken)
        );
        const guests = response.data || [];
        setAllGuestList(guests);
      } catch (error) {
        console.error("Error fetching guests:", error);
      }
    };

    fetchGuests();
  }, []);

  useEffect(() => {
    const filteredGuests = allGuestList.filter((guest) => {
      return !attendData?.some(
        (att) => att.email?.toLowerCase() === guest.email?.toLowerCase()
      );
    });

    const options = filteredGuests.map((guest) => ({
      value: guest._id,
      label: `${guest.name} / ${guest.email}`,
      profilePicture: guest.profilePicture,
      email: guest.email,
    }));

    setExistingGuestOptions(options);
  }, [allGuestList, attendData]);

  const checkHandler = (e, uid) => {
    const { checked } = e.target;

    if (uid) {
    } else {
      setFormData({
        ...formData,
        isAction: !formData.isAction,
      });
    }
    if (minuteData?.isAction === false) {
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);
    }
  };

  const handleChange = (e) => {
    setErrors({});

    const { name, value } = e.target;

    // If the field is "email", convert the value to lowercase
    const updatedValue = name === "email" ? value.toLowerCase() : value;

    setFormData({
      ...formData,
      [name]: updatedValue,
    });

    if (updatedValue === "fromEmployeeList") {
      setAddNewPeopleType(""); //

      const payload = {
        organizationId: userData.organizationId,
      };
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);
      dispatch(getEmployeeList(payload, accessToken));
    }
    if (updatedValue === "fromCurrentMeeting") {
      setAddNewPeopleType(""); //
      setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
    }

    if (updatedValue === "addNewPeople") {
      setSelectedEmployeeOption([{ label: "*Name / Emp Id", value: "" }]);
      setSelectedAttendeeOption([
        { label: "*Name / Email Address", value: "" },
      ]);
    }
    if (value === "addNewPeople") {
      setAddNewSubOption(""); //

      const getGuests = async () => {
        try {
          const response = await dispatch(
            fetchExistingGuest(userData.organizationId, accessToken)
          );

          const guestData = response.data.map((value) => {
            return {
              value: value._id,
              label: `${value.name}/${value.email}`,
            };
          });

          setExistingGuestOptions(guestData);
        } catch (error) {
          console.error("error", error);
        }
      };
      getGuests();
    }
    if (name === "attendyType" && value === "addNewPeople") {
      setAddNewPeopleType("new");
    }
  };

  const validateMinuteDescription = () => {
    const errors = {};
    if (!checkEmptyString(description?.trim())) {
      errors.description = constantMessages.descriptionRequired;
    }

    setErrors(errors);
  };

  const validateMinuteTitle = () => {
    const errors = {};
    if (!formData?.title?.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (formData.title.length < 5 || formData.title.length > 200) {
      errors.title = constantMessages.titleLengthErrorMessage;
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title))
    ) {
      errors.title = constantMessages.htmlTagsNotAllowed;
    }

    setErrors(errors);
  };

  const dateFieldValidationCheck = (e) => {
    const errors = {};

    if (formData?.dueDate?.trim()) {
      const currentDate = new Date(meetingData?.meetingDetails?.date);
      const inputDate = new Date(formData?.dueDate);
      let differenceInTime = inputDate.getTime() - currentDate.getTime();
      let differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));
      if (differenceInDays < 0) {
        errors.date = constantMessages.dateMoreThanMeetingDate;
      }
    } else if (!formData?.dueDate?.trim()) {
      errors.date = constantMessages.dateRequired;
    }
    setErrors(errors);
  };

  const nameFieldValidationCheck = (e) => {
    const errors = {};

    if (!formData?.name?.trim()) {
      errors.name = constantMessages.nameRequired;
    } else if (!regularExpressionName.test(formData.name)) {
      errors.name = constantMessages.invalidName;
    } else if (
      formData.name.trim().length < 2 ||
      formData.name.trim().length > 100
    ) {
      errors.name = constantMessages.nameLengthError;
    }
    setErrors(errors);
  };

  const emailFieldValidationCheck = () => {
    const errors = {};
    const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData?.email?.trim()) {
      errors.email = constantMessages.emailRequired;
    } else if (!validEmailRegex.test(formData.email)) {
      errors.email = constantMessages.invalidEmail;
    }
    setErrors(errors);
  };

  const validateForm = () => {
    setErrors({});
    const errors = {};
    const isAddNewPeople = formData?.attendyType === "addNewPeople";
    // if (addNewPeopleType === "new") {
    //   // Name validation
    //   if (!formData?.name?.trim()) {
    //     errors.name = constantMessages.nameRequired;
    //   } else if (!regularExpressionName.test(formData.name)) {
    //     errors.name = constantMessages.invalidName;
    //   } else if (
    //     formData.name.trim().length < 2 ||
    //     formData.name.trim().length > 100
    //   ) {
    //     errors.name = constantMessages.nameLengthError;
    //   }

    //   // Email validation
    //   if (!formData?.email?.trim()) {
    //     errors.email = constantMessages.emailRequired;
    //   } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    //     errors.email = constantMessages.invalidEmail;
    //   }

    //   // Designation validation
    //   if (formData?.designation?.trim()) {
    //     if (!regularExpression.test(formData.designation)) {
    //       errors.designation = constantMessages.invalidDesignation;
    //     } else if (
    //       formData.designation.length < 2 ||
    //       formData.designation.length > 100
    //     ) {
    //       errors.designation = constantMessages.characterSizeDesignation;
    //     }
    //   }

    //   // Company name validation
    //   if (formData?.companyName?.trim()) {
    //     if (!regularExpression.test(formData.companyName)) {
    //       errors.companyName = constantMessages.invalidCompanyName;
    //     } else if (
    //       formData.companyName.length < 2 ||
    //       formData.companyName.length > 50
    //     ) {
    //       errors.companyName = "Company name must be between 2-50 characters.";
    //     }
    //   }
    //   // Roles validation
    //   if (formData?.role?.trim()) {
    //     if (!regularExpression.test(formData.role)) {
    //       errors.role = constantMessages.invalidInput;
    //     } else if (formData.role.length < 2 || formData.role.length > 100) {
    //       errors.role = "Role must be between 2-100 characters.";
    //     }
    //   }
    //   // Department validation
    //   if (formData?.department?.trim()) {
    //     if (!regularExpression.test(formData.department)) {
    //       errors.department = constantMessages.invalidInput;
    //     } else if (
    //       formData.department.length < 2 ||
    //       formData.department.length > 100
    //     ) {
    //       errors.department = "Department must be between 2-100 characters.";
    //     }
    //   }
    // } else {
    //   // Responsible person validation
    //   // if (
    //   //   !formData?.responsiblePersonId?.trim() &&
    //   //   formData?.isAction &&
    //   //   (!formData?.name?.trim() || !formData?.email?.trim())
    //   // ) {
    //   //   errors.responsiblePersonId = constantMessages.responsiblePersonRequired;
    //   // }
    // }
    if (isAddNewPeople && addNewPeopleType === "existing") {
      // Must have selected existing guest
      if (formData.email === null) {
        errors.responsiblePerson = constantMessages.responsiblePersonRequired;
      }
    }
    // Title validation
    if (!formData?.title?.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (
      formData.title.trim().length < 5 ||
      formData.title.trim().length > 200
    ) {
      errors.title = "Title must be between 5-200 characters";
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title.trim()))
    ) {
      errors.title = constantMessages.htmlTagsNotAllowed;
    }

    // Description validation
    if (!checkEmptyString(description?.trim())) {
      errors.description = constantMessages.descriptionRequired;
    }

    // Due date validation (if isAction)
    if (formData?.isAction) {
      if (formData?.dueDate?.trim()) {
        const currentDate = new Date(meetingData?.meetingDetails?.date);
        const inputDate = new Date(formData.dueDate);
        const diffDays = Math.round(
          (inputDate.getTime() - currentDate.getTime()) / (1000 * 3600 * 24)
        );
        if (diffDays < 0) {
          errors.date = constantMessages.dateMoreThanMeetingDate;
        }
      } else {
        errors.date = constantMessages.dateRequired;
      }

      // Priority validation
      if (!formData?.priority?.trim()) {
        errors.priority = constantMessages.priorityRequired;
      }

      //replaced
      if (
        !attendData ||
        attendData.length === 0 ||
        (attendData.every(
          (item) =>
            (!item._id || item._id.trim() === "") &&
            (!item.email || item.email.trim() === "")
        ) &&
          formData?.isAction)
      ) {
        //alert("in last")
        errors.responsiblePerson = constantMessages.responsiblePersonRequired;
      }
    }


    return errors;
  };

  // const onAddMinute = () => {
  //   const newErrors = validateForm();

  //   setErrors(newErrors);

  //   if (Object.keys(newErrors).length === 0) {
  //     let isNewUser = false;
  //     let name, email;
  //     let assignedUserId;

  //     const responsiblePersonId =
  //       formData.responsiblePersonId === "" &&
  //         formData.name === "" &&
  //         formData.email === ""
  //         ? ""
  //         : formData.responsiblePersonId;

  //     if (addNewPeopleType === "new") {
  //       isNewUser = true;
  //       name = formData.name?.trim();
  //       email = formData.email?.trim();
  //     } else if (
  //       addNewPeopleType === "existing" &&
  //       selectedExistingGuestOption
  //     ) {
  //       isNewUser = true;
  //       const [guestName, guestEmail] =
  //         selectedExistingGuestOption.label.split("/");
  //       name = guestName.trim();
  //       email = guestEmail.trim();
  //       assignedUserId = selectedExistingGuestOption.value;
  //     }
  //     const newMinuteData = {
  //       organizationId: userData?.organizationId,
  //       meetingId: meetingData?.meetingDetails?._id?.toString(),
  //       title: cleanInput(formData.title),
  //       description: encryptWithAES(description),
  //       dueDate:
  //         formData.isAction === true && formData.dueDate !== ""
  //           ? formData.dueDate
  //           : undefined,
  //       priority:
  //         formData.isAction === true && formData.priority !== ""
  //           ? formData.priority
  //           : undefined,
  //       isNewUser,
  //       assignedUserId:
  //         formData.isAction === true
  //           ? assignedUserId || responsiblePersonId || undefined
  //           : undefined,
  //       isAction: formData.isAction,
  //       name: isNewUser ? name : undefined,
  //       email: isNewUser ? email : undefined,
  //       designation:
  //         formData.designation?.trim() && isNewUser === true
  //           ? formData.designation.trim()
  //           : undefined,
  //       companyName:
  //         formData.companyName?.trim() && isNewUser === true
  //           ? formData.companyName.trim()
  //           : undefined,
  //     };

  //     dispatch(updateMinute(newMinuteData, minuteData._id, accessToken));
  //   }
  // };

  console.log("attendData", attendData);
  const formattedAssignedUsers = attendData
    ?.map((user) => {
      const userId =
        typeof user._id === "object" && user._id !== null ? user._id : user._id;

      return {
        _id: typeof userId === "string" ? userId.trim() : undefined,
        name: user.name?.trim() || "",
        email: user.email?.trim() || "",
        profilePicture: user.profilePicture || "",
        isNewUser: user.isNewUser || false,
        companyName: user.companyName || "",
        designation: user.designation || "",
        role: user.role || "",
        department: user.department || "",
      };
    })
    .filter(
      (user) =>
        user.name &&
        user.email &&
        (typeof user._id === "string" || user.isNewUser)
    );

  console.log("formattedAssignedUsers", formattedAssignedUsers);

  const onAddMinute = () => {
    const newErrors = validateForm();
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      let isNewUser = false;
      let name, email;

      const isAddNewPeople = formData.attendyType === "addNewPeople";
      const isAction = formData.isAction === true;
      console.log("isAddNewPeople", isAddNewPeople);

      // if (addNewPeopleType === "new") {
      //   isNewUser = true;
      //   name = formData.name?.trim();
      //   email = formData.email?.trim();
      // } else if (addNewPeopleType === "existing" && selectedExistingGuestOption) {
      //   isNewUser = true;
      //   const [guestName, guestEmail] =
      //     selectedExistingGuestOption.label.split("/");
      //   name = guestName.trim();
      //   email = guestEmail.trim();
      //   const assignedUserId = selectedExistingGuestOption.value;
      //   if (assignedUserId && !formattedAssignedUsers.find(u => u._id === assignedUserId)) {
      //     formattedAssignedUsers.push({
      //       _id: assignedUserId,
      //       name,
      //       email,
      //       profilePicture: "",
      //     });
      //   }
      // }

      console.log("formattedAssignedUsers ->", formattedAssignedUsers);

      // Step: Sanitize
      const purifiedAssignedUsers = formattedAssignedUsers
        ?.filter((user) => {
          const _id = user._id;
          return typeof id === "string" && _id.trim() !== "";
        })
        .map((user) => ({
          _id: user._id.trim(),
          name: user.name?.trim() || "",
          email: user.email?.trim() || "",
          profilePicture: user.profilePicture || "",
        }));

      const newMinuteData = {
        organizationId: userData?.organizationId,
        meetingId: meetingData?.meetingDetails?._id?.toString(),
        title: cleanInput(formData.title),
        description: encryptWithAES(description),
        dueDate:
          isAction && formData.dueDate !== "" ? formData.dueDate : undefined,
        priority:
          isAction && formData.priority !== "" ? formData.priority : undefined,
        isNewUser,
        assignedUserId: isAction ? formattedAssignedUsers : undefined,
        isAction: isAction || false,
        name: isNewUser ? name : undefined,
        email: isNewUser ? email : undefined,
        designation:
          formData.designation?.trim() && isNewUser
            ? formData.designation.trim()
            : undefined,
        companyName:
          formData.companyName?.trim() && isNewUser
            ? formData.companyName.trim()
            : undefined,
        department:
          formData.department?.trim() && isNewUser
            ? formData.department.trim()
            : undefined,
        role:
          formData.role?.trim() && isNewUser ? formData.role.trim() : undefined,
      };

      dispatch(updateMinute(newMinuteData, minuteData._id, accessToken));
    }
  };

  // if (meetingData?.currentAttendeesList?.length !== 0) {
  //   var attendeeOptions =
  //     meetingData?.currentAttendeesList &&
  //     meetingData?.currentAttendeesList?.map((attendee) => {
  //       const returnData = {
  //         value: attendee._id,
  //         label: attendee.name + " / " + attendee.email,
  //         name: "responsiblePersonId",
  //       };

  //       return returnData;
  //     });
  // }

  const handleAttendeeChange = (e) => {
    setErrors({});

    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedAttendeeOption(e);
  };
  const handleEmployeeChange = (e) => {
    setErrors({});

    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedEmployeeOption(e);
  };

  const handleGuestChange = (e) => {
    setErrors({});
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedExistingGuestOption(e);
  };

  // if (employeeData?.employeeList?.length !== 0) {
  //   // var employeeOptions = employeeData?.employeeList?.map((attendee) => {
  //   //   const returnData = {
  //   //     value: attendee._id,
  //   //     label: attendee.name + " / " + attendee.empId,
  //   //     name: "responsiblePersonId",
  //   //   };

  //   //   return returnData;
  //   // });
  //   var employeeOptions = employeeData?.employeeList?.map((attendee) => {
  //     const returnData = {
  //       value: attendee._id,
  //       label: attendee.name + " / " + attendee.empId,
  //       email: attendee.email,
  //       profilePicture: attendee.profilePicture,
  //       name: "attendeeId",
  //     };
  //     // const returnData = attendee
  //     console.log(returnData)
  //     return returnData;
  //   });
  // }
  const handleValue = (value) => {
    setErrors({});

    setDescription(value);
  };

  const resetModal = () => {
    if (minuteData?.dueDate) {
      var date = new Date(minuteData?.dueDate);
      var dateString = new Date(
        date?.getTime() - date?.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0];
    }
    setDescription(decryptWithAES(minuteData?.description));
    console.log(minuteData?.assignedUserId);
    setFormData({
      ...formData,
      title: minuteData?.title,

      dueDate: minuteData?.isAction === true ? dateString : "",
      priority: minuteData?.isAction === true ? minuteData?.priority : "",
      attendyType: "fromCurrentMeeting",
      responsibleUser: minuteData?.assignedUserId,
      isAction: minuteData?.isAction,
      name: minuteData?.name,
      email: minuteData?.email,
      designation: minuteData?.designation,
      companyName: minuteData?.companyName,
      role: minuteData?.role,
    });
    if (minuteData?.assignedUserDetails && minuteData?.isAction === true) {
      setSelectedAttendeeOption({
        value: minuteData?.assignedUserDetails?._id,
        label:
          minuteData?.assignedUserDetails?.name +
          " / " +
          minuteData?.assignedUserDetails?.email,
        name: "responsiblePersonId",
      });
    }
    setAttendData(props?.actionData?.assignedUserDetails);
    setErrors({});
  };

  const preventEnterKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const assignAction = async () => {
    const attendeesToAdd = [];
    setAddedUserError("");
    setErrors({});

    // 1. From Guest Dropdown
    if (selectedAttendeeOption && selectedAttendeeOption.value) {
      const [namePart, emailPart] = selectedAttendeeOption.label.split(" / ");
      attendeesToAdd.push({
        _id: selectedAttendeeOption.value,
        name: namePart.trim(),
        email: emailPart.trim(),
        isEmployee: selectedAttendeeOption.isEmployee,
        profilePicture: selectedAttendeeOption.profilePicture,
        isNewUser: false,
      });
      setAttendeeOptions((prev) =>
        prev.filter((opt) => opt.value !== selectedAttendeeOption.value)
      );
    }

    // 2. From Employee Dropdown
    if (selectedEmployeeOption && selectedEmployeeOption.value) {
      attendeesToAdd.push({
        _id: selectedEmployeeOption.value,
        name: selectedEmployeeOption.label.split(" / ")[0].trim(),
        email: selectedEmployeeOption.email,
        isEmployee: selectedEmployeeOption.isEmployee,
        profilePicture: selectedEmployeeOption.profilePicture,
        isNewUser: false,
      });
      setEmployeeOptions((prev) =>
        prev.filter((opt) => opt.value !== selectedEmployeeOption.value)
      );
    }
    // if (selectedEmployeeOption && selectedEmployeeOption.value) {
    //   alert("IN EMPLOYEE")
    //   attendeesToAdd.push({
    //     id: selectedEmployeeOption.value,
    //     name: selectedEmployeeOption.label.split(" / ")[0].trim(),
    //     email: selectedEmployeeOption.email,
    //     isEmployee: selectedEmployeeOption.isEmployee,
    //     profilePicture: selectedEmployeeOption.profilePicture,
    //     isNewUser: false
    //   });
    // }

    // 3. From New or Existing Guest under "Add New People"
    if (formData.attendyType === "addNewPeople") {
      // Existing guest
      if (addNewPeopleType === "existing" && selectedExistingGuestOption) {
        const [guestName, guestEmail] =
          selectedExistingGuestOption.label.split("/");
        attendeesToAdd.push({
          _id: selectedExistingGuestOption.value,
          name: guestName.trim(),
          email: guestEmail.trim(),
          isEmployee: false,
          isNewUser: false,
        });
        setExistingGuestOptions((prev) =>
          prev.filter((opt) => opt.value !== selectedExistingGuestOption.value)
        );
      }

      // New guest
      else if (addNewPeopleType === "new" && formData.name && formData.email) {
        const duplicateInToAdd = attendeesToAdd.find(
          (u) => u.email.toLowerCase() === formData.email.toLowerCase()
        );
        if (duplicateInToAdd) {
          setErrors({ duplicateAttendee: constantMessages.duplicateAttendee });
          return;
        }

        const duplicateInExisting = attendData?.find(
          (att) => att.email?.toLowerCase() === formData.email.toLowerCase()
        );
        if (duplicateInExisting) {
          setAddedUserError(constantMessages.attendeeExist);
          setTimeout(() => setAddedUserError(""), 3000);
          return;
        }

        try {
          const payload = {
            organizationId: userData.organizationId,
            email: formData.email,
          };

          await new Promise((resolve) => {
            dispatch(checkDuplicateUser(payload, accessToken));
            setTimeout(resolve, 1000);
          });

          if (employeeData.isDuplicateUser === true) {
            setAddedUserError(
              "This email is already registered in the system!"
            );
            setTimeout(() => setAddedUserError(""), 3000);
            return;
          }

          attendeesToAdd.push({
            name: formData.name,
            email: formData.email,
            companyName: formData.companyName || "",
            designation: formData.designation || "",
            department: formData.department || "",
            role: formData.role || "",
            isNewUser: true,
          });
          console.log("attendeesToAdd->", attendeesToAdd);
          setFormData((prev) => ({
            ...prev,
            name: "",
            email: "",
            designation: "",
            companyName: "",
            role: "",
            department: "",
          }));
        } catch (error) {
          console.error("Error checking for duplicate user:", error);
          setAddedUserError("Error checking user. Please try again.");
          setTimeout(() => setAddedUserError(""), 3000);
          return;
        }
      }
    }

    // if (attendeesToAdd.length === 0) return;
    if (attendeesToAdd.length === 0 && addNewPeopleType !== "new") {
      const newErrors = { ...errors };
      // alert("3");
      newErrors.responsiblePerson = constantMessages.responsiblePersonRequired;
      setErrors(newErrors);
      setTimeout(() => setErrors(""), 3000);
      return;
    }
    if (attendeesToAdd.length === 0 && addNewPeopleType === "new") {
      const newErrors = { ...errors };
      // newErrors.responsiblePerson = constantMessages.responsiblePersonRequired;
      newErrors.name = constantMessages.nameRequired;
      newErrors.email = constantMessages.emailRequired;
      setErrors(newErrors);
      setTimeout(() => setErrors(""), 3000);
      return;
    }

    setAttendData((prevAttendData) => {
      const existing = prevAttendData || [];

      const normalizedExisting = existing.map(({ _id, ...rest }) => ({
        _id: _id || rest._id,
        ...rest,
      }));

      const normalizedToAdd = attendeesToAdd.map(({ _id, ...rest }) => ({
        _id: _id || rest._id,
        ...rest,
      }));

      const validToAdd = normalizedToAdd.filter(
        (att) => att.name?.trim() && att.email?.trim()
      );

      const uniqueAttendees = [
        ...normalizedExisting,
        ...validToAdd.filter(
          (newOne) =>
            !normalizedExisting.some(
              (existingOne) =>
                existingOne.email?.toLowerCase() === newOne.email?.toLowerCase()
            )
        ),
      ];

      if (uniqueAttendees.length === existing.length) {
        setAddedUserError(constantMessages.attendeeExist);
        setTimeout(() => setAddedUserError(""), 3000);
        return prevAttendData;
      }

      return uniqueAttendees;
    });

    setSelectedAttendeeOption(null);
    setSelectedEmployeeOption(null);
    setSelectedExistingGuestOption(null);
  };

  // const removeAttendee = () => {
  //   if (!removeAttendeeData) return;

  //   const filteredAttendees = attendData.filter((attendee) => {
  //     const attendeeId = attendee.id || attendee._id || "";
  //     const removeId = removeAttendeeData.id || removeAttendeeData._id || "";
  //     const attendeeEmail = attendee.email?.trim();
  //     const removeEmail = removeAttendeeData.email?.trim();

  //     return (
  //       attendeeId !== removeId &&
  //       attendeeEmail !== removeEmail
  //     );
  //   });
  //   console.log("Filtered Attendees:", filteredAttendees);
  //   setAttendData(
  //     filteredAttendees.map((attendee) => ({
  //       id: attendee._id || attendee.id,
  //       name: attendee.name || "",
  //       email: attendee.email || "",
  //       profilePicture: attendee.profilePicture || "",
  //       isNewUser: attendee.isNewUser
  //     }))
  //   );

  //   const removedId = removeAttendeeData._id || removeAttendeeData.id;
  //   if (
  //     formData.responsibleUser === removedId ||
  //     (Array.isArray(formData.responsibleUser) &&
  //       formData.responsibleUser.includes(removedId))
  //   ) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       responsibleUser: Array.isArray(prev.responsibleUser)
  //         ? prev.responsibleUser.filter((id) => id !== removedId)
  //         : null,
  //     }));
  //   }
  //   setIsModalOpen(false);
  // };

  const removeAttendee = (e) => {
    const filteredAttendees = attendData?.filter(
      (item) => item.email !== removeAttendeeData?.email
    );

    console.log("Filtered Attendees:", filteredAttendees);
    console.log("attendee-->", attendData);
    setAttendData(
      filteredAttendees.map((attendee) => ({
        _id: attendee._id,
        name: attendee.name,
        email: attendee.email,
        profilePicture: attendee.profilePicture,
        isNewUser: attendee.isNewUser,
      }))
    );
    console.log("ATTENDEE DATA->", attendData);
    setIsModalOpen(false);
    setFormData({
      ...formData,
      responsibleUser: [],
    });
  };

  const updatedAttendeesData = (attendees) => {
    console.log(attendees);
    // alert("CALEEDEVEE EBEBEBEEB")
    console.log(props?.actionData?.assignedUserDetails);
    setAttendData(props?.actionData?.assignedUserDetails);
  };

  const closeModal = () => {
    setErrors({});
    props.setIsAddMinuteModal(false);
    setFormData({
      title: "",
      date: "",
      priority: "",
      attendyType: "fromCurrentMeeting",
      // responsiblePersonId: "",
      responsibleUser: [],
      isAction: false,
      name: "",
      email: "",
      companyName: "",
      designation: "",
      role: "",
      department: "",
    });
    setAttendData([{ _id: "", name: "", email: "", profilePicture: "" }]);
    setDescription("");
  };
  console.log("=====", attendData);

  return (
    <>
      <Modal
        size="lg"
        show={props.IsEditMinuteModal}
        onHide={(e) => props.setIsEditMinuteModal(false)}
        backdrop="static"
      >
        <div className="modal-header attendees-modal">
          <div>
            <h4 className="modal-title">Edit Minute</h4>
          </div>

          <div className="d-flex gap-4 action-right-option">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={(e) => props.setIsEditMinuteModal(false)}
            ></button>
          </div>
        </div>

        <Modal.Body className="modal-margin">
          <div className="open-div">
            <form className="addminutesboxfrom">
              <div
                className={
                  props.isMinuteShow && props.index === props.currentIndex
                    ? "minutes-box no-border show"
                    : !props.isMinuteShow && props.index === props.currentIndex
                      ? "minutes-box no-border"
                      : "minutes-box no-border"
                }
              >
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">
                        Minutes Title <span className="star-mark">*</span>
                      </label>
                    </div>
                    <div className="col-md-12">
                      <input
                        type="text"
                        placeholder="Enter minutes title"
                        name="title"
                        value={formData.title}
                        autoComplete="off"
                        onBlur={validateMinuteTitle}
                        onChange={handleChange}
                      />
                      {errors.title ? (
                        <span className="error-message">{errors.title}</span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">
                        Description <span className="star-mark">*</span>
                      </label>
                    </div>
                    <div className="col-md-82">
                      <ReactQuill
                        theme="snow"
                        placeholder="Please add description"
                        onChange={handleValue}
                        value={description}
                        modules={modules}
                        formats={formats}
                        style={{ background: "white" }} // Adjust height here
                        onBlur={validateMinuteDescription}
                        className="custom-quill-editor"
                      />
                      {description ? (
                        <p className="success-message">
                          {getStringLengthAfterHTMLParse(description)}{" "}
                          Characters
                        </p>
                      ) : null}
                      {errors.description ? (
                        <span className="error-message">
                          {errors.description}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="add-action">
                  {formData.isAction ? (
                    <>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                          <div className="form-group">
                            <div className="position-relative">
                              <label className="mb-1 input-date">
                                {" "}
                                Due Date <span className="star-mark">*</span>
                              </label>
                              <div
                                onClick={() =>
                                  document
                                    .getElementById("dateInput")
                                    .showPicker()
                                }
                              >
                                <input
                                  type="date"
                                  name="dueDate"
                                  id="dateInput"
                                  value={formData.dueDate}
                                  onChange={handleChange}
                                  onBlur={dateFieldValidationCheck}
                                />
                              </div>
                            </div>
                            {errors.date && (
                              <span className="error-message">
                                {errors.date}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-12">
                          <div className="form-group">
                            <div className="position-relative">
                              <label className="mb-1 input-date">
                                Priority <span className="star-mark">*</span>
                              </label>
                              {minuteData.priority &&
                                minuteData?.isAction === true ? (
                                <div>
                                  <select
                                    name="priority"
                                    id="priority"
                                    onChange={handleChange}
                                  >
                                    <option value={minuteData.priority}>
                                      {minuteData.priority
                                        .charAt(0)
                                        .toUpperCase() +
                                        minuteData.priority
                                          .slice(1)
                                          .toLowerCase()}
                                    </option>

                                    {minuteData.priority.toUpperCase() !==
                                      "HIGH" ? (
                                      <option value="HIGH">High</option>
                                    ) : null}
                                    {minuteData.priority.toUpperCase() !==
                                      "LOW" ? (
                                      <option value="LOW">Low</option>
                                    ) : null}
                                    {minuteData.priority.toUpperCase() !==
                                      "NORMAL" ? (
                                      <option value="NORMAL">Normal</option>
                                    ) : null}
                                  </select>
                                </div>
                              ) : null}

                              {minuteData?.isAction === false ? (
                                <div>
                                  <select
                                    name="priority"
                                    id="priority"
                                    onChange={handleChange}
                                  >
                                    <option>Select Priority</option>
                                    <option value="HIGH">High</option>
                                    <option value="LOW">Low</option>
                                    <option value="NORMAL">Normal</option>
                                  </select>
                                </div>
                              ) : null}
                            </div>
                            {errors.priority ? (
                              <span className="error-message">
                                {errors.priority}
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="mb-1">
                          Select Responsible Person{" "}
                          <span className="star-mark">*</span>
                        </label>
                        <RemoveAttendeesModalAction
                          isModalOpen={isModalOpen}
                          setIsModalOpen={setIsModalOpen}
                          attendee={removeAttendeeData}
                          meetingData={meetingData}
                          allowRemove={true}
                          message="Are you sure want to remove this attendee?"
                          handleSubmit={() =>
                            removeAttendee(
                              props?.actionData?.assignedUserDetails
                            )
                          }
                        />
                        <AttendeeDragDropNew
                          attendees={attendData}
                          updatedAttendeesData={updatedAttendeesData}
                          setIsModalOpen={setIsModalOpen}
                          setRemoveAttendeeData={setRemoveAttendeeData}
                          allowRemove={true}
                        />
                        <div className="w-100 mb-2 mt-2 edit-minute-modal-later">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="attendyType"
                              value="fromCurrentMeeting"
                              id="flexRadioDefault1"
                              onChange={handleChange}
                              checked={
                                formData.attendyType === "fromCurrentMeeting"
                              }
                            />
                            <label
                              className="form-check-label"
                              for="flexRadioDefault1"
                              id="flexRadioDefault1"
                            >
                              Select From Current Meetings
                            </label>
                          </div>

                          <div className="form-check-inline">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="attendyType"
                                value="fromEmployeeList"
                                id="flexRadioDefault2"
                                onChange={handleChange}
                                checked={
                                  formData.attendyType === "fromEmployeeList"
                                }
                              />
                              <label
                                className="form-check-label"
                                for="flexRadioDefault2"
                                id="flexRadioDefault2"
                              >
                                Select From Employees
                              </label>
                            </div>
                          </div>

                          <div className="form-check-inline">
                            <div className="form-check">
                              <input
                                className="form-check-input z-index-high"
                                type="radio"
                                name="attendyType"
                                value="addNewPeople"
                                id="flexRadioDefault3"
                                checked={
                                  formData.attendyType === "addNewPeople"
                                }
                                onChange={handleChange}
                              />
                              <label
                                className="form-check-label"
                                for="flexRadioDefault3"
                                id="flexRadioDefault3"
                              >
                                Add New Guest
                              </label>
                            </div>
                          </div>
                        </div>

                        {formData.attendyType === "fromCurrentMeeting" ? (
                          <Select
                            className="fltr-opt"
                            placeholder="Name / Email Address"
                            name="responsiblePersonId"
                            options={attendeeOptions}
                            onChange={handleAttendeeChange}
                            value={selectedAttendeeOption}
                          />
                        ) : formData.attendyType === "fromEmployeeList" ? (
                          <Select
                            className="fltr-opt"
                            placeholder="Name / Employee ID"
                            name="responsiblePersonId"
                            options={employeeOptions}
                            value={selectedEmployeeOption}
                            onChange={handleEmployeeChange}
                          />
                        ) : formData.attendyType === "addNewPeople" ? (
                          <div className="mt-2">
                            <label className="mb-1">Select Guest Type</label>
                            <Select
                              className="fltr-opt mt-0"
                              name="addNewPeopleType"
                              placeholder="Select Guest Type"
                              options={guestTypeOptions}
                              onChange={(selectedOption) =>
                                setAddNewPeopleType(selectedOption.value)
                              }
                              value={guestTypeOptions.find(
                                (opt) => opt.value === addNewPeopleType
                              )}
                            />

                            {addNewPeopleType === "new" ? (
                              <div className="mt-3">
                                <label className="mb-1">Add New Guest</label>
                                <div className="row">
                                  <div className="col-xl-6 col-md-6">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="*Name"
                                      name="name"
                                      onKeyDown={preventEnterKey}
                                      value={formData.name}
                                      onChange={handleChange}
                                      onBlur={nameFieldValidationCheck}
                                    />
                                    {errors.name && (
                                      <span className="error-message">
                                        {errors.name}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-xl-6 col-md-6 resp-mt-2">
                                    <input
                                      type="text"
                                      placeholder="*Email"
                                      autoComplete="off"
                                      name="email"
                                      value={formData.email}
                                      onKeyDown={preventEnterKey}
                                      onBlur={emailFieldValidationCheck}
                                      onChange={handleChange}
                                    />
                                    {errors.email && (
                                      <span className="error-message">
                                        {errors.email}
                                      </span>
                                    )}
                                  </div>

                                  <div className="col-xl-6 col-md-6 mt-2">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Designation"
                                      name="designation"
                                      onKeyDown={preventEnterKey}
                                      value={formData.designation}
                                      onChange={handleChange}
                                    />
                                    {errors.designation && (
                                      <span className="error-message">
                                        {errors.designation}
                                      </span>
                                    )}
                                  </div>

                                  <div className="col-xl-6 col-md-6 mt-2">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Company Name"
                                      name="companyName"
                                      onKeyDown={preventEnterKey}
                                      value={formData.companyName}
                                      onChange={handleChange}
                                    />
                                    {errors.companyName && (
                                      <span className="error-message">
                                        {errors.companyName}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-xl-6 col-md-6 mt-2">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Role"
                                      name="role"
                                      onKeyDown={preventEnterKey}
                                      value={formData.role}
                                      onChange={handleChange}
                                    />
                                    {errors.role && (
                                      <span className="error-message">
                                        {errors.role}
                                      </span>
                                    )}
                                  </div>

                                  <div className="col-xl-6 col-md-6 mt-2">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      placeholder="Department"
                                      name="department"
                                      onKeyDown={preventEnterKey}
                                      value={formData.department}
                                      onChange={handleChange}
                                    />
                                    {errors.department && (
                                      <span className="error-message">
                                        {errors.department}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : addNewPeopleType === "existing" ? (
                              <>
                                <div className="mt-3">
                                  <label className="mb-1">
                                    Select Existing
                                  </label>
                                  <Select
                                    className="fltr-opt"
                                    placeholder="*Name / Email Address"
                                    name="attendeeId"
                                    // defaultValue={existingGuestOptions}
                                    options={existingGuestOptions}
                                    onChange={handleGuestChange}
                                    value={selectedExistingGuestOption}
                                  />
                                </div>
                              </>
                            ) : null}
                          </div>
                        ) : null}
                        {errors.responsiblePerson && (
                          <span className="error-message">
                            {errors.responsiblePerson}
                          </span>
                        )}
                      </div>
                      <button
                        type="button"
                        className="btn add-btn Mom-btn d-flex align-items-center justify-content-center "
                        onClick={assignAction}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="#fff"
                          className="bi bi-plus-circle pointer me-2"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                        </svg>
                        <p> Add </p>
                      </button>
                    </>
                  ) : null}
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-between">
          <div className="form-group">
            <div className=" mt-1 mb-1 d-flex justify-content-between align-items-center ">
              <div className="form-check input-checkbox">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexCheckDefault"
                  name="isAction"
                  onChange={checkHandler}
                  checked={formData.isAction}
                />
                <label
                  className="form-check-label add-action-bold"
                  id="flexCheckDefault"
                  for="flexCheckDefault"
                >
                  Add Action
                </label>
              </div>
            </div>
          </div>
          <div className="d-flex action-right-option">
            <Button
              variant=""
              className="add-btn Mom-btn me-2"
              onClick={() => resetModal()}
            >
              <p> Reset</p>
            </Button>

            {!minuteDatas.loading ? (
              <Button
                variant=""
                onClick={onAddMinute}
                className="create-meeting-button Mom-btn"
              >
                <p>Update</p>
              </Button>
            ) : (
              <div className="meeting-page " style={{ textAlign: "center" }}>
                <SmallLoaderButton />
              </div>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditMinuteModal;
